import {O} from "web-vcore";
import {ToneMappingMode} from "../maps/@MapState/MapSettings.js";
import {store} from "../../index.js";

export enum VRSettingsSubpanel {
	general = "general",
	lhq = "lhq",
}

export enum VRAction {
	conceptLinkNextSequence = "conceptLinkNextSequence",
	markFrameLieAndPlayRCEffect = "markFrameLieAndPlayRCEffect",
	memoryPalacePrompt = "memoryPalacePrompt",
}

export class VRSettingsState {
	@O accessor subpanel = VRSettingsSubpanel.general;

	/** Tone-mapping mode for the VR/LHQ scene, using the same enum as the map's terrain setting. Applied to the renderer at runtime. */
	@O accessor toneMapping = ToneMappingMode.AgXToneMapping;

	// todo; MARKER_1

	// as session host
	// ==========

	// new version, where individual effect-requests get sent from semi-client (remote) to semi-host (this instance, if this is checked) [needs unification/reworking]
	@O accessor receiveRemoteEffects = false;

	// as session client
	// ==========

	// new version, where individual effect-requests get sent from semi-client (this instance, if this is checked) to semi-host (remote) [needs unification/reworking]
	@O accessor sendRemoteEffects = false;

	@O accessor dreamPanel_ttsVolumeMultiplier = 1;
	@O accessor dreamPanel_ttsSpeedMultiplier = 1;

	@O accessor conceptLink_ttsVolumeMultiplier = 1;

	@O accessor imageFrame_transferSize = 0; // in pixels
	@O accessor imageFrame_transferQuality = .8;
	@O accessor imageFrame_timeoutForResend = 3000;
	@O accessor imageFrame_preloadCount = 3; // how many frames beyond the active one to pre-load
	@O accessor imageFrame_expireAfter = 3; // how many "frames in the past" a frame must be before it's considered "expired", and gets its image/video data cleared (to save memory)
	@O accessor imageFrame_swapDirectionalControls = false;
	@O accessor imageFrame_swapControllers = false;
	@O accessor bButtonAction = VRAction.memoryPalacePrompt;
	@O accessor memoryPalaceSnapshotBlurSize = .15; // as percent of image width
	@O accessor stats_show = true;
	@O accessor stats_opacity = 0.1;

	// todo: add settings for customizing the resize/compression of video-clips (atm it's locked to 720p, 15fps, 1mbps bitrate)

	@O accessor headsetOnWhenAbove = 1.05; // in meters
	@O accessor headsetOffWhenBelow = .9; // in meters
}

export const GetControllerSide_Final = (side: "left" | "right")=>{
	if (store.main.settings.vr.imageFrame_swapControllers) {
		return side == "left" ? "right" : "left";
	}
	return side;
};